/**
 * PRD.330 — Small report-only icons (NavIcon has no funnel/sort glyphs).
 * State is carried by SHAPE (outline vs filled funnel, arrow direction), not
 * colour alone, and every consumer also sets an accessible label.
 */

export function FunnelIcon({ active }: { active: boolean }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill={active ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M3 4h18l-7 8.5V19l-4 2v-8.5L3 4z" />
    </svg>
  );
}

export function SortIcon({ direction }: { direction: 'asc' | 'desc' | null }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {direction === 'asc' && <path d="M12 19V5M5 12l7-7 7 7" />}
      {direction === 'desc' && <path d="M12 5v14M19 12l-7 7-7-7" />}
      {direction === null && <path d="M8 9l4-4 4 4M16 15l-4 4-4-4" />}
    </svg>
  );
}
